import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApproveBankProofDocumentState, approveBankProofDocumentFeatureKey } from '../reducers/approve-bankproof-document.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as approvedState from '../reducers/approve-bankproof-document.reducer';
import { AddBankState, addBankFeatureKey } from '../reducers/add-bank.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, AddBankState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Approve SUB STATE
export const getAddBankState = createSelector(getMainEmployeeState, state => state[addBankFeatureKey]);
//#endregion

//#region Employee Approve docs SUB STATE
import * as fromAddBankReducer from '../reducers/add-bank.reducer';

export const selectAddBankRequest = createSelector(getAddBankState, fromAddBankReducer.getAddBankRequest);
export const selectAddBankSuccess = createSelector(getAddBankState, fromAddBankReducer.getAddBankSuccess);
export const selectAddBankFailure = createSelector(getAddBankState, fromAddBankReducer.getAddBankFailure);
//#endregion
